import { render } from "./KnotTimer.vue?vue&type=template&id=20804dfc&scoped=true"
import script from "./KnotTimer.vue?vue&type=script&lang=js"
export * from "./KnotTimer.vue?vue&type=script&lang=js"

import "./KnotTimer.vue?vue&type=style&index=0&id=20804dfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20804dfc"]])

export default __exports__